import PendingAssetEditor from "../../shared/PendingAssetEditor";
import React, { useEffect, useState } from "react";
import axios from "axios";
import PendingAssetDeleteButton from "../../shared/PendingAssetDeleteButton";
import "./pendingassetDetails.css";
import { Link , useNavigate} from "react-router-dom";
import * as XLSX from "xlsx";
import { departmentCodes } from "../../Data/departmentcode";
import { companyCodes } from "../../Data/Companycode";
import useAutoRefresh from "../../../hooks/useAutoRefresh";
import useDebouncedValue from "../../../hooks/useDebouncedValue";
import AssetPagination from "../../shared/AssetPagination";

const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const MAX_EXCEL_IMPORT_ROWS = 2000;

const PendingAssetDetails = () => {
  const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
  const [transferAssetDetails, setTransferAssetDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [assetDetailsView, setAssetDetailsView] = useState(
    "pendingregisterAsset",
  );
  const [editAsset, setEditAsset] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });
  const serverSearch = useDebouncedValue(
    [searchQuery, searchQuery1, searchQuery2].filter(Boolean).join(" "),
  );

  const handleFileUpload = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  const reader = new FileReader();

  reader.onload = async (evt) => {
    const data = new Uint8Array(evt.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(sheet);

    console.log("Excel Data:", jsonData);

    if (jsonData.length === 0) {
      alert("The Excel worksheet contains no data rows.");
      e.target.value = "";
      return;
    }

    if (jsonData.length > MAX_EXCEL_IMPORT_ROWS) {
      alert(
        `A maximum of ${MAX_EXCEL_IMPORT_ROWS} rows can be imported at one time. This file contains ${jsonData.length} rows.`
      );
      e.target.value = "";
      return;
    }

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/PendingAssetRegisterDetails/import`,
        { assets: jsonData }
      );
      alert(response.data?.message || "Assets imported successfully!");
    } catch (error) {
      console.error("Excel import failed:", error);
      alert(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Unable to import the Excel file. Please check its data."
      );
    } finally {
      e.target.value = "";
    }
  };

  reader.readAsArrayBuffer(file);
};

  useEffect(() => {
    if (assetDetailsView === "pendingregisterAsset") {
      fetchRegisterAssets();
    } else {
      fetchTransferAssets();
    }
  }, [assetDetailsView, page, serverSearch]);

  const fetchRegisterAssets = () => {
    axios
      .get(
        "/api/PendingAssetRegisterDetails/getPendingAssetDetails",
        { params: { paginated: true, page, limit: 100, search: serverSearch } },
      )
      .then((response) => {
        setAssetRegisterDetails(response.data.assets);
        setPagination(response.data.pagination);
      })
      .catch((error) =>
        console.error("Error fetching register asset details:", error),
      );
  };

  const fetchTransferAssets = () => {
    axios
      .get(
        "/api/transfer/getPendingTransferAssetDetails",
        { params: { paginated: true, page, limit: 100, search: serverSearch } },
      )
      .then((response) => {
        setTransferAssetDetails(response.data.assets);
        setPagination(response.data.pagination);
      })
      .catch((error) =>
        console.error("Error fetching transfer asset details:", error),
      );
  };

  useAutoRefresh(() => {
    if (assetDetailsView === "pendingregisterAsset") {
      fetchRegisterAssets();
    } else {
      fetchTransferAssets();
    }
  });

  const handleDetailsView = (e) => {
    setPage(1);
    setAssetDetailsView(e.target.value);
  };

  const handleEditClick = (asset) => {
    setEditAsset(asset);
  };

  // AUTO GENERATE TRACKING ID WHEN SERIAL NUMBER CHANGES


  

  // FILTER LOGIC
  const queryMatch = (query, asset) =>
    (asset.name?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.company?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.department?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.category?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.type?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetName?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetUserName?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetModel?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.serialNumber?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.trackingId?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.subComponent?.toLowerCase() || "").includes(
      query.toLowerCase(),
    ) ||
    (asset.conditionType?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.invoiceDetails?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.specialNote?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.warranty?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.supplierName?.toLowerCase() || "").includes(query.toLowerCase());

  const filteredAssets =
    assetDetailsView === "pendingregisterAsset"
      ? assetRegisterDetails.filter((asset) =>
          [searchQuery, searchQuery1, searchQuery2].every(
            (query) => !query || queryMatch(query, asset),
          ),
        )
      : transferAssetDetails.filter((asset) =>
          [searchQuery, searchQuery1, searchQuery2].every(
            (query) => !query || queryMatch(query, asset),
          ),
        );

const handleHandoverNote = (asset) => {
    navigate("/HandoverNote", { state: { asset } });
  };

  const navigate = useNavigate();


  

  return (
    <div className="row details2">
      <div className="col-md-14">
        <h1 className="assethead">Pending Asset Details</h1>

        <p>
          <Link to="/AdminDashboardPage">Dashboard</Link> /
          <Link to="/pendingRegisterasset"> Pending Asset Details</Link>
        </p>

        {/* VIEW SWITCH */}
        <div className="radio-toggle-container mb-4">
          <label
            className={`radio-option1 ${
              assetDetailsView === "pendingregisterAsset" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              value="pendingregisterAsset"
              name="view"
              checked={assetDetailsView === "pendingregisterAsset"}
              onChange={handleDetailsView}
            />
            Pending Register Asset
          </label>

          <label
            className={`radio-option1 ${
              assetDetailsView === "pendingtransferasset" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              value="pendingtransferasset"
              name="view"
              checked={assetDetailsView === "pendingtransferasset"}
              onChange={handleDetailsView}
            />
            Pending Transfer Asset
          </label>
        </div>

        {/* SEARCH */}
        <div className="row">
          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value); setPage(1); }}
            />
          </div>

          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search by category/type/name..."
              value={searchQuery1}
              onChange={(e) => { setSearchQuery1(e.target.value); setPage(1); }}
            />
          </div>

          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search by model/serial/tracking..."
              value={searchQuery2}
              onChange={(e) => { setSearchQuery2(e.target.value); setPage(1); }}
            /> 
          </div><div className="col-md-2 col-12 mb-2">  <label className="import-btn">
    <i className="fas fa-file-excel"></i>
    <span>Import Excel</span>
    <input
      type="file"
      accept=".xlsx, .xls"
      hidden
      onChange={handleFileUpload}
    />
  </label></div>
    
        </div>

        {/* TABLE */}
        <div className="table-responsive mt-3">
          <table className="table table-bordered table-light custom_table">
            <thead className="thead-dark">
              <tr>
                <th>Register Name</th>
                <th>Company</th>
                <th>Department</th>
                <th>Category</th>
                <th>Condition Type</th>
                <th>Type</th>
                <th>Asset</th>
                <th>EPF No & Recipient Name</th>
                <th>Model</th>
                <th>Register Date</th>
                {assetDetailsView === "pendingtransferasset" && (
                  <th>Transfer Date</th>
                )}
                <th>Serial</th>
                <th>Tracking ID</th>
                <th>Price</th>
                <th>Note</th>
                <th>Components</th>
                <th>Asset Image</th>
                <th>Invoice Image</th>
                <th>Warranty</th>
                <th>Supplier Name</th>
                <th>Invoice Number</th>
                <th>Purchase Date</th>
                <th>Handover Note</th>

                <th>Status</th>
               {(assetDetailsView === "pendingregisterAsset" ||
                  assetDetailsView === "pendingtransferasset") && <th>Edit</th>}
              </tr>
            </thead>

            <tbody>
              {filteredAssets.length > 0 ? (
                filteredAssets.map((asset) => (
                  <tr key={asset._id}>
                    <td>{asset.name}</td>
                    <td>{asset.company}</td>
                    <td>{asset.department}</td>
                    <td>{asset.category}</td>
                    <td>{asset.conditionType}</td>
                    <td>{asset.type}</td>
                    <td>{asset.assetName}</td>
                    <td>{asset.assetUserName}</td>
                    <td>{asset.assetModel}</td>
                    <td>{asset.assetUpdateDate}</td>
                    {assetDetailsView === "pendingtransferasset" && (
                      <td>{asset.assetTransferDate || "N/A"}</td>
                    )}
                    <td>{asset.serialNumber}</td>
                    <td>{asset.trackingId}</td>
                    <td>{asset.assetprice}</td>
                    <td>{asset.specialNote}</td>
                    <td>{asset.subComponent}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>

                    <td>{asset.warranty}</td>
                    <td>{asset.supplierName}</td>
                    <td>{asset.invoiceDetails}</td>
                    <td>{asset.purchaseDate}</td>
                    <td>
                      <button
                        className="handoverbtn"
                        onClick={() => handleHandoverNote(asset)}
                      >
                        <i className="fas fa-download"></i> Handover
                      </button>
                    </td>
                    <td>
                      <button className="status">Pending</button>
                    </td>
                  <td>
                      {(assetDetailsView === "pendingregisterAsset" ||
                        assetDetailsView === "pendingtransferasset") && (
                        <>
                        <button
                          className="editstsatus"
                          onClick={() => handleEditClick(asset)}
                        >
                          Edit
                        </button>
                        <PendingAssetDeleteButton
                       
                          asset={asset}
                          isTransfer={assetDetailsView === "pendingtransferasset"}
                          onDeleted={(id) =>
                            assetDetailsView === "pendingregisterAsset"
                              ? setAssetRegisterDetails((items) => items.filter((item) => item._id !== id))
                              : setTransferAssetDetails((items) => items.filter((item) => item._id !== id))
                          }
                        />
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">
                    No matching asset data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <AssetPagination
          page={pagination.page || page}
          totalPages={pagination.totalPages}
          total={pagination.total}
          onPageChange={setPage}
        />

        {/* EDIT MODAL */}
        {editAsset && <PendingAssetEditor key={editAsset._id} asset={editAsset} onClose={() => setEditAsset(null)} onSaved={updated => { setEditAsset(null); fetchRegisterAssets(); }} />}
      </div>
    </div>
  );
};

export default PendingAssetDetails;
